<template>
  <form-item label-width="80" labelAlign="left" label="时间偏移">
    <el-switch v-model="temData.isDateExcursion" :active-value="1" :inactive-value="0" :disabled="!uniqCol.length"/>
  </form-item>
  <template v-if="temData.isDateExcursion">
    <form-item label-width="80" labelAlign="left" label="偏移条件">
      <el-select v-model="temData.contrastIndex" clearable size="small" @change="changeDate">
        <el-option v-for="item in uniqCol" :label="item.name" :value="item.code"></el-option>
      </el-select>
    </form-item>
    <form-item label-width="80" labelAlign="left" label="时间维度">
      <el-select v-model="temData.dateDim" clearable size="small">
        <el-option v-for="item in list" :label="item.name" :value="item.value"></el-option>
      </el-select>
    </form-item>
    <form-item label-width="80" labelAlign="left" label="偏移量" v-if="temData.dateDim">
      <div>
        <el-radio-group v-model="temData.offset">
          <template v-if="temData.dateDim === 'year'">
            <el-radio label="lastYearSame">去年同期</el-radio>
          </template>
          <template v-else-if="temData.dateDim === 'month'">
            <el-radio label="lastMonth">上月</el-radio>
            <el-radio label="lastQuarter">上季度</el-radio>
            <el-radio label="lastYearSame">去年同期</el-radio>
          </template>
          <template v-else>
            <el-radio label="yesterday">昨天</el-radio>
            <el-radio label="lastWeek">上周</el-radio>
            <el-radio label="lastMonth">上月</el-radio>
            <el-radio label="lastQuarter">上季度</el-radio>
            <el-radio label="lastYearSame">去年同期</el-radio>
          </template>
          <el-radio label="custom">自定义</el-radio>
        </el-radio-group>
        <div class="mt-10" v-if="temData.offset === 'custom'">
          <div class="offset-tip p-10 mb-10">数值代表偏移量，符号代表方向，如选择[月]+[-1]则偏移到上月。</div>
          <div class="flex">
            <el-select v-model="temData.offsetDateDim" clearable size="small">
              <el-option v-for="item in offsetDateDimList" :label="item.name" :value="item.value"></el-option>
            </el-select>
            <el-input-number class="ml-10" :step="1" controls v-model="temData.offsetValue"/>
          </div>
        </div>
      </div>
    </form-item>
  </template>
</template>
<script setup>
import {computed, ref} from "vue";
import {cloneDeep, uniqBy} from "lodash-es";

let props = defineProps({
  temData: {},
  option: {},
});
let originList = [
  {
    name: "年",
    value: "year",
  },
  {
    name: "月",
    value: "month",
  },
  {
    name: "日",
    value: "day",
  },
  {
    name: "时",
    value: "hour",
  },
  {
    name: "分",
    value: "minute",
  },
  {
    name: "秒",
    value: "second",
  },
]
let list = ref(cloneDeep(originList));

let colList = computed(() => {
  let filterDatas = props.option.filterDatas
  let list = []
  getDateList(list, [filterDatas]);
  return list
})
let uniqCol = computed(() => {
  return uniqBy(colList.value, 'code') || []
})

function changeDate(v) {
  if (v) {
    let dateList = colList.value.filter(el => el.code === v).map(el => el.funcType)
    list.value = originList.filter(el => dateList.includes(el.value))
  } else {
    list.value = cloneDeep(originList)
  }
  props.temData.dateDim = ''
}

function getDateList(arr, list) {
  list.forEach((el) => {
    if (Array.isArray(el?.conditions)) {
      el.conditions.forEach((_el) => {
        if (_el.fieldType === "Date") {
          arr.push({
            code: _el.code,
            funcType: _el.funcType,
            name: _el.fieldMap.name,
          })
        }
      })
    }
    if (Array.isArray(el?.children)) {
      getDateList(arr, el.children)
    }
  })

}

let offsetDateDimList = computed(() => {
  let index = originList.findIndex((el) => el.value === props.temData.dateDim);
  return originList.slice(0, index + 1);
});
</script>

<style scoped lang="scss">
.offset-tip {
  border-radius: 6px;
  background-color: rgba(0, 137, 255, 0.12);
  box-shadow: none;
}
</style>
